/**
 * Membership sub-layout — renders a sticky pill nav across the 5
 * membership management pages. Nested under /owner/membership.
 */
import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, Crown, Wallet, Award, UserCheck } from 'lucide-react';

const TABS = [
  { to: '/owner/membership/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/owner/membership/tiers',     label: 'Tiers',     icon: Crown },
  { to: '/owner/membership/plans',     label: 'Plans',     icon: Wallet },
  { to: '/owner/membership/benefits',  label: 'Benefits',  icon: Award },
  { to: '/owner/membership/members',   label: 'Members',   icon: UserCheck },
];

export default function MembershipLayout() {
  return (
    <div data-testid="owner-membership-layout">
      <nav
        className="flex flex-wrap items-center gap-2 mb-6 -mt-2"
        data-testid="owner-membership-subnav"
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              'inline-flex items-center gap-2 px-3 py-1.5 rounded-2xl text-xs font-semibold transition-colors border ' +
              (isActive
                ? 'bg-gold/15 text-gold border-gold/35 shadow-glow-gold-sm'
                : 'bg-white/3 text-white/65 border-white/8 hover:text-white hover:border-white/15')
            }
            data-testid={`owner-membership-subnav-${t.to.split('/').pop()}`}
          >
            <t.icon size={12} />
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
